import { render, staticRenderFns } from "./Poblation.vue?vue&type=template&id=00ea934e&scoped=true&"
import script from "./Poblation.vue?vue&type=script&lang=js&"
export * from "./Poblation.vue?vue&type=script&lang=js&"
import style0 from "./Poblation.vue?vue&type=style&index=0&id=00ea934e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ea934e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/ctorres/Documents/Dev/MCD/lsm-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
